import api from './api';
import {
  TTISettingsCreate,
  TTISettingsResponse,
  TTISettingsVerifyResponse,
  TTIApplicationCreate,
  TTIApplicationCreateResponse,
  TTIApplicationsListResponse,
} from '../types';

export const ttiSettingsService = {
  /**
   * Create or update TTI settings (API key and region).
   */
  async createOrUpdateSettings(data: TTISettingsCreate): Promise<TTISettingsResponse> {
    const response = await api.post<TTISettingsResponse>('/api/tti-settings/', data);
    return response.data;
  },

  /**
   * Get current TTI settings status.
   */
  async getSettings(): Promise<TTISettingsResponse> {
    const response = await api.get<TTISettingsResponse>('/api/tti-settings/status');
    return response.data;
  },

  /**
   * Verify the stored TTI API key.
   */
  async verifySettings(): Promise<TTISettingsVerifyResponse> {
    const response = await api.post<TTISettingsVerifyResponse>('/api/tti-settings/verify');
    return response.data;
  },

  /**
   * Delete TTI settings.
   */
  async deleteSettings(): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>('/api/tti-settings/');
    return response.data;
  },

  /**
   * List TTI applications using the stored API key.
   */
  async listApplications(): Promise<TTIApplicationsListResponse> {
    const response = await api.get<TTIApplicationsListResponse>('/api/tti-settings/applications');
    return response.data;
  },

  /**
   * Create a new TTI application using the stored API key.
   */
  async createApplication(data: TTIApplicationCreate): Promise<TTIApplicationCreateResponse> {
    const response = await api.post<TTIApplicationCreateResponse>('/api/tti-settings/applications', data);
    return response.data;
  },
};
